import * as tslib_1 from "tslib";
import { ErrorHandler } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BusinessFinderService } from './business-finder.service';
import { FlightSchoolResult } from '../models/flight-school-result.model';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
/**
 * HTTP service for the Flight School Finder. Calls the AirportsAPI `~/flight-schools` endpoint. Category
 * facet filtering (Training Type / Certifications / Ratings / Advanced / Services / ...) is applied
 * client-side in {@link SearchPageComponent}; this service performs only the location/state/keyword query.
 */
var FlightSchoolsService = /** @class */ (function (_super) {
    tslib_1.__extends(FlightSchoolsService, _super);
    function FlightSchoolsService(http, errorHandler) {
        var _this = _super.call(this, http, errorHandler) || this;
        _this.endpoint = 'flight-schools';
        return _this;
    }
    FlightSchoolsService.prototype.parse = function (data) {
        return FlightSchoolResult.parse(data);
    };
    FlightSchoolsService.prototype.getFlightSchoolsByLatLon = function (latlon, radius) {
        return this.getByLatLon(latlon, radius);
    };
    FlightSchoolsService.prototype.getFlightSchoolsByBoundingBox = function (bounds) {
        return this.getByBoundingBox(bounds);
    };
    FlightSchoolsService.prototype.getFlightSchoolsByState = function (state) {
        return this.getByState(state);
    };
    FlightSchoolsService.prototype.getFlightSchoolsBySearchTerm = function (term) {
        return this.getBySearchTerm(term);
    };
    FlightSchoolsService.ngInjectableDef = i0.defineInjectable({ factory: function FlightSchoolsService_Factory() { return new FlightSchoolsService(i0.inject(i1.HttpClient), i0.inject(i0.ErrorHandler)); }, token: FlightSchoolsService, providedIn: "root" });
    return FlightSchoolsService;
}(BusinessFinderService));
export { FlightSchoolsService };
